import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Header from "./Common/Header"
import VehicleSelection from "./components/VehicleSelection"
import ContactDetailsPage from "./components/ContactDetailsPage"
import { BookingProvider } from "./components/BookingContext";
import Footer from "./Common/Footer"
import ContactPage from "./Pages/ContactPage"
import AboutUs from "./Pages/AboutPage"
import FAQ from "./Pages/FAQ"
import QuickBooking from "./Pages/QuickBooking"
import CustomerLogin from "./Pages/CustomerLogin"
import Login from "./Pages/Login"
import ScrollToTop from "./Pages/ScrollToTop"; // Add this import

function App() {
  return (
     <BookingProvider>
    <Router>
      <ScrollToTop /> {/* Add this line */}
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/vehicle-selection" element={<VehicleSelection />} />
        <Route path="/contact-details" element={<ContactDetailsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/quick-booking" element={<QuickBooking />} />
        <Route path="/customer-login" element={<CustomerLogin/>}/>
        <Route path="/login" element={<Login/>}/>
      </Routes>
      <Footer />
    </Router>
    </BookingProvider>
  );
}

export default App;